import axios from 'axios';
// import { Message } from 'element-ui'
// import qs from 'qs';
// import router from '../../src/router/index'

// axios.defaults.baseURL = "http://www.huashu.top:3000";
//axios.defaults.withCredentials = true; // 允许跨域携带资源凭证
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers['Content-Type'] = 'application/json'
// axios.defaults.transformRequest = data => qs.stringify(data)  // x-www-form-urlencoded post => xxx=xxx
axios.defaults.timeout = 0; // 超时时间
// 请求拦截器 客户端向服务端发送之前
axios.interceptors.request.use(config => {
  // config  包含所有请求的配置信息
  // config.headers['X-token'] = 'xxx'
  // 把token信息发给服务器
  return config
})
// 响应拦截器,从服务器获取的结果进行统一处理
axios.interceptors.response.use(response => {
  // 处理成功,默认认为状态码以2开头
  // console.log('response响应拦截器-成功态',response)
  return response
}, reason => {
  // 失败 1、获取了结果但是状态码不是2开头 2、压根没有从服务器获取数据
  if (reason.response) {
    // 获取到数据了,根据不同状态码做不同提示
    // console.log('response响应拦截器-失败态',reason.response)
    switch(reason.response.status){
      case 401:
        // Message({
        //   message: reason.response.data.err.message,
        //   type: 'warning',
        //   duration: 5 * 1000
        // });
        return reason.response
      case 404:
        // Message({
        //   message: '数据服务' + reason.response.status + '!',
        //   type: 'warning',
        //   duration: 5 * 1000
        // });
        break;
      case 500: 
        // Message({
        //   message: '服务器错误' + reason.response.status + '!',
        //   type: 'warning',
        //   duration: 5 * 1000
        // }); 
        // break;
    }
  } else {
    // Message({
    //   // message: '数据服务异常' + reason + '！',
    //   message: '暂停服务！',
    //   type: 'warning',
    //   duration: 5 * 1000
    // }); 
    // 没有获取数据
    if (!window.navigator.onLine) {
      // 断网
    //   Message({
    //     message: '请检查网络',
    //     type: 'warning',
    //     duration: 5 * 1000
    //   });
    }
  }
  return Promise.reject(reason)
  // 使用resolve：这样无论请求成功还是失败，在成功的回调中都能收到通知
  // https://blog.csdn.net/weixin_34803738/article/details/112011093
  // return Promise.resolve(reason)
})

// axios.defaults.validate...
export default axios;